import angular from 'angular';
import { values } from 'lodash';

module.exports = angular.module('common.filters.values', [])
  .filter('values', () => values)
  .name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/values.js
 **/